import {USER_ROLE, USER_ROLE_NAME, STATUS, STATUS_NAME, UserDTO} from "@/model/user";
import Company, {CompanyDTO} from "@/model/company";

export enum COOPERATION_ACCEPT {
  ACCEPT = 1,
  REJECT = 2,
}

export interface IUserCompany {
  id: string;
  company_id: string;
  company: CompanyDTO;
  user_id: string;
  role_id: USER_ROLE;
  user_name: string;
  status: STATUS;
  type: number;
  affiliation_company_id: string;
  affiliation_company_name: string;
  affiliation_company: CompanyDTO;
  requester: UserDTO;
  create_at: string;
}

export class UserCompanyDTO implements IUserCompany {
  id: string;
  company_id: string;
  company: CompanyDTO;
  user_id: string;
  user_name: string;
  role_id: USER_ROLE;
  status: STATUS;
  type: number;
  affiliation_company_id: string;
  affiliation_company_name: string;
  affiliation_company: CompanyDTO;
  requester: UserDTO;
  create_at: string;
}

export default class UserCompany extends UserCompanyDTO {
  constructor(dto?: UserCompanyDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      dto.company && (this.company = new Company(dto.company));
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      company_id: null,
      user_id: null,
      role_id: null,
      status: null,
      type: null,
      affiliation_company_id: null,
      affiliation_company_name: null,
      create_at: null,
    });
  }

  get roleName() {
    return USER_ROLE_NAME[this.role_id];
  }

  get isAdmin() {
    return this.role_id == USER_ROLE.ADMIN;
  }

  get isManager() {
    return this.role_id == USER_ROLE.MANAGE;
  }
  get companyName() {
    return this.company ? this.company.name : "";
  }

  get affiliationCompanyName() {
    return this.affiliation_company ? this.affiliation_company.name : "";
  }

  get requesterName() {
    return this.requester ? this.requester.username : "";
  }

  public getStatusName(status) {
    return STATUS_NAME[status];
  }
}
